import type { ReactNode } from 'react';
import { Group, Stack, Text, Title } from '@mantine/core';

/**
 * Seitenkopf-Muster (Brief §2, D-M0-K1 D1): Titel, Meta-Zeile (Zähler plus
 * aktive Filter), genau eine Aktion rechts (Primär- oder Sekundäraktion).
 */
export function PageHeader({
  title,
  meta,
  action,
}: {
  title: string;
  meta: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Group justify="space-between" align="flex-end">
      <Stack gap={2}>
        <Title order={2}>{title}</Title>
        <Text c="dimmed" size="sm">
          {meta}
        </Text>
      </Stack>
      {action}
    </Group>
  );
}
